module.exports = __webpack_public_path__ + "img/logo-financiado-union-europea.9ea3c23d.png";